import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-form-field-spaceholder-v2',
    templateUrl: './form-field-spaceholder-v2.component.html',
    styleUrls: ['./form-field-spaceholder-v2.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FormFieldSpaceholderV2Component {

  constructor() { }

}
